/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface SellTypesRSSellTypes {

        "SellType"?: Array<SellType>;
    }

}
